<template>
  <div class="agent-manager" style="display: flex;">
    <!-- Left: List Table -->
    <div style="flex: 4; padding: 24px 0 0px 24px;    background: rgb(101, 101, 101);border-radius: 20px;    margin-right: 10px;    text-align: left;">
      <!-- Search Bar -->
      <el-input
        placeholder="输入所属代理/群名/群ID/到期日期筛选"
        prefix-icon="el-icon-search"
        v-model="search"
        clearable
        class="round-input"
        style="margin-bottom: 12px; width: 360px;"
        
      />
      <!-- Table -->
      <el-table
        :data="filteredRooms"
        border
        height="calc(100vh - 180px)"
        style="width: 100%; background: rgb(101, 101, 101); color: #fff;"
        @row-click="handleRowClick"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="room_id" label="群ID"></el-table-column>
        <el-table-column prop="room_name" label="群名"></el-table-column>
        <el-table-column prop="expire_time" label="到期时间" :formatter="formatDate" sortable></el-table-column>
        <el-table-column prop="status" label="群状态"  :formatter="formatStatus" :filters="roomStatusFilters" :filter-method="filterRoomStatus" filter-placement="bottom-end"></el-table-column>
        <el-table-column prop="proxy_name" label="所属代理"></el-table-column>
      </el-table>
    </div>

    <!-- Right: Form Panel-->
    <div style="flex: 1; border-radius: 16px;">
      <!-- Edit Agent Form -->
      <div style="font-size: 18px; font-weight: bold; margin-bottom: 8px;">
          <i class="el-icon-edit"></i> 修改代理详情
        </div>
      <el-card shadow="never" style="background: #656565; color: #fff;">
        
        <el-form :model="editForm" label-width="80px">
          <el-form-item label="群ID">
            <span>{{ editForm.room_id || '请选择' }}</span>
          </el-form-item>
          <el-form-item label="群名">
            <span>{{ editForm.room_name || '请选择' }}</span>
          </el-form-item>
          <el-form-item label="群状态">
            <span>{{ formatStatusText(editForm.status) }}</span>
          </el-form-item>
          <el-form-item label="到期时间">
            <span>{{ formatDate1(editForm.expire_time) }}</span>
            <!-- <el-date-picker size="small" v-model="editForm.expire" type="date" placeholder="到期时间" style="width: 100%;" /> -->
          </el-form-item>
          <div style="text-align:left;margin-top: 30px;font-size: 12px;">
            <span>卡密使用详情</span>
            <div class="usage-row usage-header">
              <span>使用人</span>
              <span>卡类型</span>
              <span>使用时间</span>
            </div>
            <div class="usage-row" :key="log.id" v-for="log in uselog">
              <span>{{ log.use_nick_name }}</span>
              <span>{{ getCardModeName(log.carmine_type) }}</span>
              <span>{{ formatLogTime(log.use_time) }}</span>
            </div>
          </div>
          <div>
            <el-button size="small" type="primary" @click="updateProxy" style="margin-left: 12px;">确认修改</el-button>
          </div>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name:"PowerPage",
  data() {
    return {
      selectedRowId: null,
      uselog:[],
      search: '',
      types: [{
        val:1,
        name:'运行中'
      },{
        val:2,
        name:'停发中'
      },{
        val:3,
        name:'停用中'
      },{
        val:4,
        name:'已过期'
      }],
      roomStatusFilters: [
        { text: '运行中', value: 1 },
        { text: '停发中', value: 2 },
        { text: '停用中', value: 3 },
        { text: '已过期', value: 4 }
      ],
      rooms: [
      ],
      proxys:[],
      addForm: {
        name: '',
        vxid: '',
        type: '',
        amount: '',
        expire: ''
      },
      editForm: {
        name: '',
        vxid: '',
        type: '',
        amount: '',
        expire: ''
      },
      cardprices:[]
    }
  },
  computed: {
    filteredRooms() {
      if (!this.search) return this.rooms;

      const keyword = this.search.toLowerCase().trim();

      return this.rooms.filter(room => {
        return (
          (room.room_name && room.room_name.toLowerCase().includes(keyword)) ||
          (room.room_id && String(room.room_id).toLowerCase().includes(keyword)) ||
          (room.expire_time && this.formatDate({}, {}, room.expire_time).includes(keyword)) ||
          (room.proxy_name && room.proxy_name.toLowerCase().includes(keyword))
        );
      })
    }
  },
  methods: {
    filterRoomStatus(value, row) {
      return row.status === value;
    },
    formatDate1(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp * 1000); // 秒转毫秒
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    formatLogTime(timestamp) {
      if (!timestamp) return '-';
      const date = new Date(timestamp * 1000); // 秒转毫秒
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },
    async handleRowClick(row) {
      this.selectedRowId = row.id;
      // 选中后把这行数据放到 editForm
      this.editForm = {
        ...row,
        expire: row.expire_time ? new Date(row.expire_time * 1000) : null
      };
      try {
        const res = await this.$axios.post('/room/carmineuselog', {
          room_id: row.room_id
        });

        if (res.code === 200) {
          this.uselog = res.data;
        } else {
          this.$message.error(res.data.msg || '查询失败');
        }
      } catch (err) {
        console.log(err);
      }
    },
    getCardModeName(val) {
      const item = this.cardprices.find(i => i.id === val)
      return item ? item.name : '-'
    },
    tableRowClassName({ row }) {
      return row.id === this.selectedRowId ? 'selected-row' : '';
    },
    async roomList(){
      try {
        const res = await this.$axios.post('/room/list', {
          'search':this.search
        })
        this.rooms = res.data;
      } catch (err) {
        console.log(err);
      }
    },
    async proxyList(){
      try {
        const res = await this.$axios.post('/proxy/list')
        this.proxys = res.data;
      } catch (err) {
        console.log(err);
      }
    },
    formatStatus(row, column, cellValue) {
      const found = this.types.find(t => t.val === cellValue);
      return found ? found.name : '-';
    },
    formatStatusText(status) {
      const found = this.types.find(t => t.val === status);
      return found ? found.name : '请选择';
    },
    formatDate(row, column, cellValue) {
      if (!cellValue) return '-';
      // 如果是秒，乘以1000变毫秒
      const date = new Date(cellValue * 1000);
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },
    addAgent() {
      this.agents.push({ ...this.addForm, group: 39 });
      this.$message.success('添加成功');
      this.addForm = { name: '', vxid: '', type: '', amount: '', expire: '' };
    },
    async updateProxy() {
      
      const expireTime = this.editForm.expire? Math.floor(this.editForm.expire.getTime() / 1000): null;
      this.editForm.expire_time = expireTime;
      try {
        await this.$axios.post('/room/update', {
          ...this.editForm
        })
        this.roomList();
      } catch (err) {
        console.log(err);
      }
    },
    deleteAgent() {
      this.agents = this.agents.filter(a => a.vxid !== this.editForm.vxid);
      this.$message.success('删除成功');
      this.editForm = { name: '', vxid: '', type: '', amount: '', expire: '' };
    },
    async cardPriceList(){
      try {
        const res = await this.$axios.post('/carmine/cardprice', {
        })
        this.cardprices = res.data;
      } catch (err) {
        console.log(err);
      }
    },
  },
  watch: {
    // 选中左侧表格某行时编辑
    filteredAgents: {
      handler(val) {
        // 可以绑定el-table @row-click事件来填充editForm
        console.log(val)
      }
    }
  },
  mounted(){
    this.cardPriceList();
    this.proxyList();
    this.roomList();
    
  }
}
</script>

<style scoped>

::v-deep .el-table .el-table__body-wrapper tbody tr.selected-row > td.el-table__cell {
  background-color: #b0b0b0 !important;
  color: #fff !important;
}
.agent-manager {
  font-family: "PingFang SC", "Helvetica Neue", Arial, "Microsoft YaHei", sans-serif;
}
.el-table th, .el-table td, .el-table tr,el-table__row {
  background: #404040 !important;
  /* color: #000 !important; */
  border-color: #656565 !important;
}
.el-table .el-table__body tr {
  background-color: rgb(101, 101, 101) !important;
}
.el-card {
  border-radius: 12px !important;
  border: none !important;
}
.round-input .el-input__inner {
  border-radius: 20px;
}

::v-deep .el-table td.el-table__cell,
::v-deep .el-table th.el-table__cell.is-leaf {
  background-color: rgb(101, 101, 101) !important;
  color: #fff !important;
}

/* 方式 1：v-deep */
::v-deep .el-table,
::v-deep .el-table th,
::v-deep .el-table td {
  border: none !important;
}

/* 如果还有伪元素残留，也可以干掉 */
::v-deep .el-table::before {
  display: none;
}

/* 去掉表头底部分割线 */
::v-deep .el-table__header-wrapper th {
  border-bottom: none !important;
}

/* 去掉表格行的分割线 */
::v-deep .el-table__row td {
  border-bottom: none !important;
}

::v-deep .el-form-item__label {
  color: #fff !important;
}

::v-deep .el-form-item {
    margin-bottom: 0px;
}

/* ::v-deep .el-input--prefix .el-input__inner {
    border-radius: 20px;
} */

::v-deep .el-date-editor{
  width:250px;
}

.usage-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr; /* 三等分 */
  padding: 6px 0;
}

.usage-header {
  font-weight: bold;
  border-bottom: 1px solid #ccc;
}

.usage-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr; /* 三等分 */
  padding: 6px 0;
}

.usage-header {
  font-weight: bold;
  border-bottom: 1px solid #ccc;
}
</style>